module.exports = __webpack_public_path__ + "img/HDR_X7000F.232cb1f3.png";